<template>
  <section id="combined-cta" class="bg-primary py-16 md:py-24">
    <div class="max-w-4xl mx-auto px-4">
      <!-- Clean section header -->
      <div class="text-center mb-12">
        <h2 class="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-white">
          {{ $t("finalCTA.heading") }}
        </h2>
      </div>

      <!-- Smart Lead Form Card -->
      <div class="card bg-base-100 shadow-xl">
        <div class="card-body">
          <SmartLeadForm @complete="onPlannerComplete" class="w-full" />

          <!-- Trust signals -->
          <div class="mt-8 space-y-4">
            <div class="alert alert-success">
              <div class="w-6 h-6 bg-success rounded-full flex items-center justify-center">
                <LucideCheck class="w-4 h-4 text-white" />
              </div>
              <span>{{ $t("finalCTA.trustSignal1") }}</span>
            </div>

            <div class="alert alert-info">
              <div class="w-6 h-6 bg-info rounded-full flex items-center justify-center">
                <LucideCheck class="w-4 h-4 text-white" />
              </div>
              <span>{{ $t("finalCTA.trustSignal2") }}</span>
            </div>

            <div class="alert alert-warning">
              <LucideAlertTriangle class="w-6 h-6" />
              <span class="font-bold">
                {{ $t("finalCTA.urgencyMessage", { remaining: spotsRemaining }) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import SmartLeadForm from "@/components/forms/SmartLeadForm/SmartLeadForm.vue";
import { useSpotsRemaining } from "./useSpotsRemaining";
import { LucideCheck, LucideAlertTriangle } from "lucide-vue-next";

const router = useRouter();
const { spotsRemaining } = useSpotsRemaining(20, 3);

async function onPlannerComplete() {
  // Wait a moment to ensure any data persistence is complete
  await new Promise(resolve => setTimeout(resolve, 50));
  router.push({ path: "/total-package/order" });
}
function goToDirectPlan() {
  router.push({ path: "/total-package/order" });
}
</script>
